import { createResource } from '../utils/resource'

const lectureContentStore = createResource('lectureContent', {})

export default lectureContentStore
